export { default } from './Course.container';
export type { Props, Props as CourseCardProps } from './Course.container';
export { default as Component } from './Course';
